import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  empdetailsid,
  empdetailsid11,
} from "../../Redux/Slice/TaskMasterSlice";
import { toggleUserPermissions } from "../../Redux/Slice/ChatSlice";
import DynamicTable from "../../Components/Table/DynamicTable";
import {
  FaMedal,
  FaClock,
  FaRunning,
  FaBusinessTime,
  FaCalendarAlt,
  FaChartLine,
  FaFilter,
  FaHeadset,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { RiInformation2Line } from "react-icons/ri";
import { TiStarFullOutline } from "react-icons/ti";
import { MdAddTask } from "react-icons/md";
import { MdOutlineAvTimer } from "react-icons/md";
import { IoMdStopwatch } from "react-icons/io";
import { MdOutlineTaskAlt } from "react-icons/md";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";
import { RiCalendarTodoLine } from "react-icons/ri";
import defaultProfile from "../../Image/Daynamic_Logo_Piture.png";

const EmpDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { empdetailsidData, empdetailsid11Data } = useSelector(
    (state) => state.TaskMaster
  );
  const [activeSection, setActiveSection] = useState("accepted");
  const [debugInfo, setDebugInfo] = useState("");
  const [loading, setLoading] = useState(true);

  // Chat permission local states
  const { LoginData } = useSelector((state) => state.auth || {});
  const isOwner = LoginData?.data?.Role === "owner";
  const [chatEnabledLocal, setChatEnabledLocal] = useState(true);
  const [sendEnabledLocal, setSendEnabledLocal] = useState(true);

  // Date range state for payroll
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });
  const [filteredInOutRows, setFilteredInOutRows] = useState([]);

  // Get all employees data for top performer calculation
  const { selectedPartyEMPDETAILS } = useSelector((state) => state.partyCall);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (id) {
        await dispatch(empdetailsid({ id }));
        await dispatch(empdetailsid11({ id }));
      }
      setTimeout(() => setLoading(false), 800);
    };
    fetchData();
  }, [dispatch, id]);

  // Get employee info from first task (assuming all tasks belong to same employee)
  const employeeInfo = empdetailsidData?.isdata;
  const userRole = employeeInfo?.Role || "";

  useEffect(() => {
    if (employeeInfo) {
      setChatEnabledLocal(employeeInfo.chatEnabled !== false);
      setSendEnabledLocal(employeeInfo.sendEnabled !== false);
    }
  }, [employeeInfo]);

  const handleChatAccessToggle = () => {
    const newVal = !chatEnabledLocal;
    setChatEnabledLocal(newVal);
    dispatch(toggleUserPermissions({ employeeId: id, chatEnabled: newVal, sendEnabled: sendEnabledLocal }));
  };

  const handleSendPermissionToggle = () => {
    const newVal = !sendEnabledLocal;
    setSendEnabledLocal(newVal);
    dispatch(toggleUserPermissions({ employeeId: id, chatEnabled: chatEnabledLocal, sendEnabled: newVal }));
  };

  const restrictedRoles = [
    "Junior Customer Support",
    "Senior Customer Support",
    "inhouse",
  ];

  // Calculate average rating - FIXED VERSION
  const calculateAverageRating = () => {
    if (
      !employeeInfo?.RatingRecord ||
      !Array.isArray(employeeInfo.RatingRecord) ||
      employeeInfo.RatingRecord.length === 0
    ) {
      return 0;
    }

    // Filter out invalid ratings (null, undefined, empty strings, NaN)
    const validRatings = employeeInfo.RatingRecord.map((record) => {
      if (!record || record.Rating === undefined || record.Rating === null) {
        return null;
      }

      const rating = parseFloat(record.Rating);
      return isNaN(rating) ? null : rating;
    }).filter((rating) => rating !== null && rating >= 0);

    if (validRatings.length === 0) {
      return 0;
    }

    const sum = validRatings.reduce((total, rating) => total + rating, 0);
    return sum / validRatings.length;
  };

  const averageRating = calculateAverageRating();
  const filledStars = Math.round(averageRating);
  const totalStars = 10;

  // Debug: Check what data we're getting
  useEffect(() => {
    if (empdetailsidData) {
      if (employeeInfo?.RatingRecord) {
        employeeInfo.RatingRecord.forEach((record, index) => {
          console.log(
            `Rating ${index + 1}:`,
            record.Rating,
            "Type:",
            typeof record.Rating
          );
        });
      }

      setDebugInfo(`
                Total RatingRecord: ${employeeInfo?.RatingRecord?.length || 0}
                Average Rating: ${averageRating}
                Valid Ratings: ${employeeInfo?.RatingRecord?.filter(
        (r) => r && r.Rating && !isNaN(parseFloat(r.Rating))
      ).length || 0
        }
            `);
    }
  }, [empdetailsidData, averageRating]);

  // Calculate top performers for each role - UPDATED with proper rating calculation
  const topPerformersByRole = React.useMemo(() => {
    if (!selectedPartyEMPDETAILS?.data) return {};

    const roleMap = {};
    const employees = selectedPartyEMPDETAILS.data;

    employees.forEach((emp) => {
      if (!emp.Role) return;

      if (!roleMap[emp.Role]) {
        roleMap[emp.Role] = [];
      }
      roleMap[emp.Role].push(emp);
    });

    const calculateRatingForEmployee = (emp) => {
      if (
        !emp.RatingRecord ||
        !Array.isArray(emp.RatingRecord) ||
        emp.RatingRecord.length === 0
      ) {
        return 0;
      }

      const validRatings = emp.RatingRecord.map((record) => {
        if (!record || record.Rating === undefined || record.Rating === null)
          return null;
        const rating = parseFloat(record.Rating);
        return isNaN(rating) ? null : rating;
      }).filter((rating) => rating !== null && rating >= 0);

      if (validRatings.length === 0) return 0;

      const sum = validRatings.reduce((total, rating) => total + rating, 0);
      return sum / validRatings.length;
    };

    const topPerformers = {};
    Object.keys(roleMap).forEach((role) => {
      const roleEmployees = roleMap[role];

      const sortedEmployees = roleEmployees.sort((a, b) => {
        const aCompleted = a.Completed || 0;
        const bCompleted = b.Completed || 0;

        if (bCompleted !== aCompleted) {
          return bCompleted - aCompleted;
        }

        const aAvgRating = calculateRatingForEmployee(a);
        const bAvgRating = calculateRatingForEmployee(b);

        return bAvgRating - aAvgRating;
      });

      if (
        sortedEmployees.length > 0 &&
        (sortedEmployees[0].Completed || 0) > 0
      ) {
        topPerformers[sortedEmployees[0]._id] = role;
      }
    });

    return topPerformers;
  }, [selectedPartyEMPDETAILS]);

  const isTopPerformer =
    employeeInfo?._id &&
    topPerformersByRole[employeeInfo._id] === employeeInfo.Role;

  // Filter tasks by status - FIXED: Check for different possible status values
  const acceptedTasks =
    empdetailsidData?.data?.filter((task) => task.Status === "Accept") || [];
  const pendingTasks =
    empdetailsidData?.data?.filter((task) => task.Status === "Pending") || [];
  const holdTasks =
    empdetailsidData?.data?.filter((task) => task.Status === "Hold") || [];

  const completedTasks =
    empdetailsidData?.data?.filter(
      (task) =>
        task.Status === "Completed" ||
        task.Status === "complete" ||
        task.Status === "COMPLETED" ||
        task.Status === "Done" ||
        task.Status === "done" ||
        task.Status === "Closed" ||
        task.Status === "closed"
    ) || [];

  //========== Customer Support ==========//
  const pendingTasksCustomer =
    empdetailsid11Data?.data?.filter((t) => t.Status === "Pending") || [];

  const completedTasksCustomer =
    empdetailsid11Data?.data?.filter(
      (t) =>
        t.Status === "Completed" || t.Status === "Done" || t.Status === "closed"
    ) || [];

  const rejectedTasksCustomer =
    empdetailsid11Data?.data?.filter(
      (t) =>
        t.Status === "Reject" ||
        t.Status === "Rejected" ||
        t.Status === "REJECTED"
    ) || [];

  // Build a map of complainId -> rating from RatingRecord (handles ConplainId being object or id string)
  const ratingMap = React.useMemo(() => {
    const map = {};
    (employeeInfo?.RatingRecord || []).forEach((r) => {
      if (!r) return;
      const con = r.ConplainId;
      let idVal = null;

      if (!con) {
        // Sometimes the RatingRecord might contain the _id in other shapes
        // fallbacks (no-op)
        idVal = null;
      } else if (typeof con === "string" || typeof con === "number") {
        idVal = String(con);
      } else if (typeof con === "object") {
        // object could be the task object or contain _id
        idVal = con._id ? String(con._id) : null;
      }

      if (idVal) {
        // store numeric/string rating safely
        const parsed =
          r.Rating === undefined || r.Rating === null
            ? null
            : parseFloat(r.Rating);
        map[idVal] = !isNaN(parsed) ? parsed : r.Rating ?? null;
      }
    });
    return map;
  }, [employeeInfo?.RatingRecord]);

  // Normalize completed tasks into task objects (if we only have RatingRecord entries then derive tasks from ConplainId)
  const completedTaskObjects = React.useMemo(() => {
    if (completedTasks && completedTasks.length > 0) {
      return completedTasks;
    }

    // If there are no explicit completed tasks, try to derive from RatingRecord
    if (employeeInfo?.RatingRecord && employeeInfo.RatingRecord.length > 0) {
      // map ConplainId to object if possible; if ConplainId is only an id string, create a minimal placeholder object
      return employeeInfo.RatingRecord.map((r) => {
        if (!r) return null;
        const con = r.ConplainId;
        if (!con) return null;

        if (typeof con === "object") {
          // if it's already the task object or reference, return it
          return con;
        } else {
          // create a small placeholder task object with id so we can show something
          return {
            _id: String(con),
            CallNo: r.CallNo || "N/A",
            CompanyName: r.CompanyName || { WhaClientName: "N/A" },
            SeniorDevloperID: r.SeniorDevloperID || { Name: "N/A" },
            Status: "Completed",
          };
        }
      }).filter(Boolean);
    }

    return [];
  }, [completedTasks, employeeInfo?.RatingRecord]);

  // Prepare final completed rows using ratingMap
  const ComholdTaskRows =
    (completedTaskObjects || []).map((taskOrRef, index) => {
      const task = taskOrRef || {};
      // determine task id safely
      const taskId = task._id
        ? String(task._id)
        : task.Id
          ? String(task.Id)
          : null;

      const ratingFromMap = taskId ? ratingMap[taskId] : null;
      const rating = ratingFromMap ?? task.Rating ?? "Not Rated";

      return {
        id: index + 1,
        CallNo: task.CallNo || (task.CallNo ? task.CallNo : "N/A"),
        CompanyName:
          task.CompanyName?.WhaClientName ||
          (task.CompanyName || {}).WhaClientName ||
          "N/A",
        SeniorDevloperID:
          task.SeniorDevloperID?.Name ||
          (task.SeniorDevloperID || {}).Name ||
          "N/A",
        Status: task.Status || "Completed",
        Rating:
          rating === null || rating === undefined || rating === ""
            ? "Not Rated"
            : rating,
        MainId: taskId || task._id || index + 1,
      };
    }) || [];

  // Keep the rest of your code unchanged (columns, rows, reports, attendance logic etc.)
  const RunningTaskColumns = [
    { field: "id", headerName: "Id", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No.", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "SeniorDevloperID",
      headerName: "Assign By",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "showTask",
      headerName: "Show Full Task",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <button
          className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 text-sm lg:text-base"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          Show Task
        </button>
      ),
    },
  ];

  const RunningTaskRows =
    pendingTasks?.map((el, index) => ({
      id: index + 1,
      CallNo: el.CallNo,
      CompanyName: el.CompanyName?.WhaClientName || "-",
      SeniorDevloperID: el.SeniorDevloperID?.Name || "N/A",
      MainId: el._id,
    })) || [];

  const holdTaskColumns = [
    { field: "id", headerName: "Id", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No.", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "SeniorDevloperID",
      headerName: "Assign By",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "showTask",
      headerName: "Show Full Task",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <button
          className="bg-blue-500 text-white px-3 py-2 rounded hover:bg-blue-600 text-sm lg:text-base"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          Show Task
        </button>
      ),
    },
  ];

  const holdTaskRows =
    holdTasks?.map((el, index) => ({
      id: index + 1,
      CallNo: el.CallNo,
      CompanyName: el.CompanyName?.WhaClientName || "N/A",
      SeniorDevloperID: el.SeniorDevloperID?.Name || "-",
      MainId: el._id,
    })) || [];

  const comTaskColumns = [
    { field: "id", headerName: "Id", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No.", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "SeniorDevloperID",
      headerName: "Assign By",
      flex: 1,
      minWidth: 120,
    },
    { field: "Status", headerName: "Status", flex: 1, minWidth: 100 },
    { field: "Rating", headerName: "Rating", flex: 1, minWidth: 80 },
    {
      field: "showTask",
      headerName: "Show Full Task",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <button
          className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          Show Task
        </button>
      ),
    },
  ];

  // Customer Support Pending Tasks Columns
  const CustomerPendingColumns = [
    { field: "id", headerName: "ID", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1.5,
      minWidth: 180,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1.2,
      minWidth: 130,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1.2,
      minWidth: 180,
      renderCell: (params) => (
        <div className="flex gap-2">
          <button
            className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
            onClick={() =>
              navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
            }
          >
            View Details
          </button>
        </div>
      ),
    },
  ];

  // Customer Support Completed Tasks Columns
  const CustomerCompletedColumns = [
    { field: "id", headerName: "ID", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1.5,
      minWidth: 180,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1.2,
      minWidth: 130,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <button
          className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          View Details
        </button>
      ),
    },
  ];

  // Customer Support Rejected Tasks Columns
  const CustomerRejectedColumns = [
    { field: "id", headerName: "ID", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No", flex: 1, minWidth: 100 },
    {
      field: "CompanyName",
      headerName: "Company Name",
      flex: 1.5,
      minWidth: 180,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1.2,
      minWidth: 130,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => (
        <button
          className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          View Details
        </button>
      ),
    },
  ];

  // Prepare Customer Support Tasks Rows
  const pendingCustomerRows = pendingTasksCustomer?.map((task, index) => ({
    id: index + 1,
    CallNo: task.CallNo || "-",
    CompanyName: task.CompanyName?.WhaClientName || "-",
    Status: task.Status || "-",
    MainId: task._id,
  }));

  const completedCustomerRows = completedTasksCustomer?.map((task, index) => ({
    id: index + 1,
    CallNo: task.CallNo || "-",
    CompanyName: task.CompanyName?.WhaClientName || "-",
    Status: task?.Status || "-",
    MainId: task._id,
  }));

  const rejectedCustomerRows = rejectedTasksCustomer?.map((task, index) => ({
    id: index + 1,
    CallNo: task.CallNo || "-",
    CompanyName: task.CompanyName?.WhaClientName || "-",
    Status: task?.Status || "-",
    MainId: task._id,
  }));

  // rest of your code (formatDisplayDate, reports, attendance logic etc.)
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    const hours = String(d.getUTCHours()).padStart(2, "0");
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  const ReportColumns = [
    { field: "id", headerName: "Id", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No.", flex: 1, minWidth: 100 },
    {
      field: "GeneratedDate",
      headerName: "Generated Date",
      flex: 1,
      minWidth: 150,
    },
    { field: "Description", headerName: "Description", flex: 1, minWidth: 200 },
    {
      field: "showTask",
      headerName: "Show Full Task",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <button
          className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          Show Task
        </button>
      ),
    },
  ];

  const ReportRows =
    empdetailsidData?.iswork?.map((el, index) => ({
      id: index + 1,
      CallNo: el.WorkId.CallNo,
      GeneratedDate: formatDisplayDate(el.GeneratedDate),
      Description: el.Description,
      MainId: el.WorkId._id,
    })) || [];

  // Group work by CallNo
  const workSummary = {};

  empdetailsidData?.iswork?.forEach((el) => {
    const callNo = el.WorkId.CallNo;

    if (!workSummary[callNo]) {
      workSummary[callNo] = {
        CallNo: callNo,
        count: 0,
        dates: [],
      };
    }

    workSummary[callNo].count += 1;
    workSummary[callNo].dates.push(el.GeneratedDate);
  });

  // Convert to array
  const SummaryRows = Object.values(workSummary).map((item, index) => {
    const sortedDates = item.dates.sort((a, b) => new Date(a) - new Date(b));

    return {
      id: index + 1,
      CallNo: item.CallNo,
      WorkCount: `${item.count} Days Work`,
      FirstDate: formatDisplayDate(sortedDates[0]),
      LastDate: formatDisplayDate(sortedDates[sortedDates.length - 1]),
      MainId:
        empdetailsidData?.iswork?.find((w) => w.WorkId.CallNo === item.CallNo)
          ?.WorkId._id || null,
    };
  });

  const SummaryColumns = [
    { field: "id", headerName: "Id", flex: 1, minWidth: 60 },
    { field: "CallNo", headerName: "Call No", flex: 1, minWidth: 100 },
    { field: "WorkCount", headerName: "Total Work", flex: 1, minWidth: 120 },
    {
      field: "FirstDate",
      headerName: "First Work Date",
      flex: 1,
      minWidth: 150,
    },
    { field: "LastDate", headerName: "Last Work Date", flex: 1, minWidth: 150 },
    {
      field: "showTask",
      headerName: "Show Full Task",
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <button
          className="px-4 py-2 rounded text-base bg-[#112A47] text-white shadow-lg hover:bg-[#0c2545] transition duration-300 ease-in-out focus:outline-none"
          onClick={() =>
            navigate(`/InhouseRnd/CustomerrequustDetail/${params.row.MainId}`)
          }
        >
          Show Task
        </button>
      ),
    },
  ];

  // Attendance & payroll logic (unchanged)
  const records = empdetailsidData?.isinout || [];

  const grouped = {};
  records.forEach((item) => {
    const date = item.InDate
      ? item.InDate.split("T")[0]
      : item.OutDate
        ? item.OutDate.split("T")[0]
        : null;

    if (!date) return;

    if (!grouped[date]) grouped[date] = [];
    grouped[date].push(item);
  });

  const attendanceData = Object.keys(grouped).map((date) => {
    const dayData = grouped[date];

    const firstIn = dayData
      .filter((i) => i.InDate)
      .sort((a, b) => new Date(a.InDate) - new Date(b.InDate))[0];

    const lastOut = dayData
      .filter((i) => i.OutDate)
      .sort((a, b) => new Date(b.OutDate) - new Date(a.OutDate))[0];

    const inTime = firstIn ? new Date(firstIn.InDate) : null;
    const outTime = lastOut ? new Date(lastOut.OutDate) : null;

    const inHour = inTime ? inTime.getUTCHours() : null;
    const inMinutes = inTime ? inTime.getUTCMinutes() : null;
    const outHour = outTime ? outTime.getUTCHours() : null;
    const outMinutes = outTime ? outTime.getUTCMinutes() : null;

    const empCheckIn = employeeInfo?.CheckInTime || "10:00";
    const empCheckOut = employeeInfo?.CheckOutTime || "19:00";
    const [startHour, startMin] = empCheckIn.split(":").map(Number);
    const [endHour, endMin] = empCheckOut.split(":").map(Number);

    let inStatus = "On Time";
    let outStatus = "On Time";
    let inStatusType = "success";
    let outStatusType = "success";

    if (inTime) {
      if (
        inHour < startHour ||
        (inHour === startHour && inMinutes <= startMin)
      ) {
        inStatus = "On Time";
        if (inHour < startHour || (inHour === startHour && inMinutes < startMin)) {
          inStatus = "Early In";
        }
        inStatusType = "info";
      } else {
        inStatus = "Late In";
        inStatusType = "warning";
      }
    } else {
      inStatus = "No In Record";
      inStatusType = "error";
    }

    if (outTime) {
      // Check-out between 12:00 AM and 6:00 AM is considered late out (night shift/overtime) rather than early out
      const isAfterMidnight = outHour < 6;

      if (
        !isAfterMidnight &&
        (outHour < endHour || (outHour === endHour && outMinutes < endMin))
      ) {
        outStatus = "Early Out";
        outStatusType = "warning";
      } else {
        outStatus = "On Time";
        if (isAfterMidnight || outHour > endHour || (outHour === endHour && outMinutes > endMin)) {
          outStatus = "Late Out";
        }
        outStatusType = "info";
      }
    } else {
      outStatus = "No Out Record";
      outStatusType = "error";
    }

    return {
      date,
      firstIn: firstIn?.InDate || null,
      lastOut: lastOut?.OutDate || null,
      inStatus,
      outStatus,
      inStatusType,
      outStatusType,
      hasIrregularity: inStatus !== "On Time" || outStatus !== "On Time",
      rawDate: date,
    };
  });

  const formatTimeDisplay = (dateStr) => {
    if (!dateStr) return "N/A";

    const d = new Date(dateStr);
    const hours = String(d.getUTCHours()).padStart(2, "0");
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  const getStatusBadge = (status, type) => {
    const baseClasses = "px-2 py-1 rounded-full text-xs font-semibold";

    switch (type) {
      case "success":
        return `${baseClasses} bg-green-100 text-green-800`;
      case "info":
        return `${baseClasses} bg-blue-100 text-blue-800`;
      case "warning":
        return `${baseClasses} bg-yellow-100 text-yellow-800`;
      case "error":
        return `${baseClasses} bg-red-100 text-red-800`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800`;
    }
  };

  const formatDisplayDatePayroll = (dateStr) => {
    if (!dateStr) return "";

    const d = new Date(dateStr);

    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const year = d.getUTCFullYear();

    return `${day}-${month}-${year}`;
  };

  const InOutColumns = [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 50 },
    { field: "date", headerName: "Date", flex: 1, minWidth: 100 },
    { field: "firstIn", headerName: "First In", flex: 1, minWidth: 80 },
    { field: "inStatus", headerName: "In Status", flex: 1, minWidth: 100 },
    { field: "lastOut", headerName: "Last Out", flex: 1, minWidth: 80 },
    { field: "outStatus", headerName: "Out Status", flex: 1, minWidth: 100 },
    { field: "remarks", headerName: "Remarks", flex: 1.5, minWidth: 120 },
  ];

  const initialInOutRows = attendanceData.map((item, index) => {
    const remarks = [];
    if (item.inStatus !== "On Time") remarks.push(item.inStatus);
    if (item.outStatus !== "On Time") remarks.push(item.outStatus);
    if (remarks.length === 0) remarks.push("Normal Day");

    return {
      id: index + 1,
      date: formatDisplayDatePayroll(item.date),
      firstIn: formatTimeDisplay(item.firstIn),
      lastOut: formatTimeDisplay(item.lastOut),
      inStatus: (
        <span className={getStatusBadge(item.inStatus, item.inStatusType)}>
          {item.inStatus}
        </span>
      ),
      outStatus: (
        <span className={getStatusBadge(item.outStatus, item.outStatusType)}>
          {item.outStatus}
        </span>
      ),
      remarks: remarks.join(" + "),
      hasIrregularity: item.hasIrregularity,
      rawDate: item.rawDate,
    };
  });

  const last30DaysRows = React.useMemo(() => {
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    thirtyDaysAgo.setHours(0, 0, 0, 0);

    return initialInOutRows.filter((row) => {
      const rowDate = new Date(row.rawDate);
      return rowDate >= thirtyDaysAgo;
    });
  }, [initialInOutRows]);

  const filterByDateRange = (rows, startDate, endDate) => {
    if (!startDate && !endDate) return rows;

    return rows.filter((row) => {
      const rowDate = new Date(row.rawDate);
      const start = startDate ? new Date(startDate) : null;
      const end = endDate ? new Date(endDate) : null;

      if (start && end) {
        return rowDate >= start && rowDate <= end;
      } else if (start) {
        return rowDate >= start;
      } else if (end) {
        return rowDate <= end;
      }
      return true;
    });
  };

  useEffect(() => {
    if (activeSection === "payroll") {
      if (dateRange.startDate || dateRange.endDate) {
        const filtered = filterByDateRange(
          initialInOutRows,
          dateRange.startDate,
          dateRange.endDate
        );
        setFilteredInOutRows(filtered);
      } else {
        setFilteredInOutRows(last30DaysRows);
      }
    }
  }, [dateRange, initialInOutRows, last30DaysRows, activeSection]);

  useEffect(() => {
    if (activeSection !== "payroll") {
      setDateRange({ startDate: "", endDate: "" });
    }
  }, [activeSection]);

  const lateRows = filteredInOutRows.filter(
    (row) => row.inStatus.props.children === "Late In"
  );

  const earlyRows = filteredInOutRows.filter(
    (row) => row.outStatus.props.children === "Early Out"
  );

  const toHHMM = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  let totalLateMinutes = 0;
  let totalEarlyMinutes = 0;

  const empCheckInVal = employeeInfo?.CheckInTime || "10:00";
  const empCheckOutVal = employeeInfo?.CheckOutTime || "19:00";
  const [startHourVal, startMinVal] = empCheckInVal.split(":").map(Number);
  const [endHourVal, endMinVal] = empCheckOutVal.split(":").map(Number);

  filteredInOutRows.forEach((row) => {
    if (row.inStatus.props.children === "Late In" && row.firstIn !== "N/A") {
      const [h, m] = row.firstIn.split(":").map(Number);
      const actualIn = new Date(0, 0, 0, h, m);
      const officeIn = new Date(0, 0, 0, startHourVal, startMinVal);
      const diff = Math.floor((actualIn - officeIn) / 60000);
      totalLateMinutes += diff;
    }

    if (row.outStatus.props.children === "Early Out" && row.lastOut !== "N/A") {
      const [h, m] = row.lastOut.split(":").map(Number);
      const actualOut = new Date(0, 0, 0, h, m);
      const officeOut = new Date(0, 0, 0, endHourVal, endMinVal);
      const diff = Math.floor((officeOut - actualOut) / 60000);
      totalEarlyMinutes += diff;
    }
  });

  const totalLateHHMM = toHHMM(totalLateMinutes);
  const totalEarlyHHMM = toHHMM(totalEarlyMinutes);

  const calculatePunctualityScore = () => {
    if (filteredInOutRows.length === 0) return 100;
    const onTimeDays = filteredInOutRows.filter(
      (row) =>
        row.inStatus.props.children !== "Late In" &&
        row.outStatus.props.children !== "Early Out"
    ).length;
    return Math.round((onTimeDays / filteredInOutRows.length) * 100);
  };

  const handleDateRangeChange = (e) => {
    const { name, value } = e.target;
    setDateRange((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const clearDateRange = () => {
    setDateRange({ startDate: "", endDate: "" });
  };

  const isRestrictedRole = restrictedRoles.includes(userRole);

  const navButtons = [
    {
      key: "accepted",
      label: "Accepted Task",
      count: acceptedTasks.length,
      icon: MdAddTask,
      showForAll: true,
      hideForRestricted: true, // Hide for restricted roles
    },
    {
      key: "inqueue",
      label: "In Queue Task",
      count: pendingTasks.length,
      icon: MdOutlineAvTimer,
      showForAll: true,
      hideForRestricted: true, // Hide for restricted roles
    },
    {
      key: "hold",
      label: "Hold Task",
      count: holdTasks.length,
      icon: IoMdStopwatch,
      showForAll: true,
      hideForRestricted: true, // Hide for restricted roles
    },
    {
      key: "complete",
      label: "Complete Task",
      count: ComholdTaskRows.length,
      icon: MdOutlineTaskAlt,
      showForAll: true,
      hideForRestricted: true, // Hide for restricted roles
    },
    {
      key: "dailywork",
      label: "Daily Work Report",
      count: ReportRows.length,
      icon: FaCalendarAlt,
      showForAll: true,
      hideForRestricted: true, // Hide for restricted roles
    },

    // Customer Support Sections - ONLY for restricted roles
    {
      key: "Customer_pending",
      label: "Call Pending",
      count: pendingTasksCustomer.length,
      icon: FaHeadset,
      showForRestricted: true, // Only show for restricted roles
    },
    {
      key: "Customer_completed",
      label: "Call Completed",
      count: completedTasksCustomer.length,
      icon: FaCheckCircle,
      showForRestricted: true,
    },
    {
      key: "Customer_rejected",
      label: "Call Rejected",
      count: rejectedTasksCustomer.length,
      icon: FaTimesCircle,
      showForRestricted: true,
    },

    {
      key: "worksummary",
      label: "Work Summary By Call",
      count: SummaryRows.length,
      icon: TbDeviceDesktopAnalytics,
      showForAll: true,
      hideForRoles: ["inhouse"], // Hide for inhouse role
    },
    {
      key: "payroll",
      label: "Payroll",
      count: initialInOutRows.length,
      icon: RiCalendarTodoLine,
      showForAll: true,
    },
  ];

  const filteredNavButtons = navButtons.filter((button) => {
    // If button should be hidden for restricted roles
    if (isRestrictedRole && button.hideForRestricted) {
      return false;
    }

    // If button should be hidden for specific roles
    if (button.hideForRoles && button.hideForRoles.includes(userRole)) {
      return false;
    }

    // If button is only for restricted roles
    if (button.showForRestricted) {
      return isRestrictedRole;
    }

    // If button is for all (and not hidden for this role)
    if (button.showForAll) {
      return true;
    }

    return false;
  });

  const addHHMM = (time1, time2) => {
    const [h1, m1] = time1.split(":").map(Number);
    const [h2, m2] = time2.split(":").map(Number);

    const totalMinutes = h1 * 60 + m1 + h2 * 60 + m2;

    const hh = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
    const mm = String(totalMinutes % 60).padStart(2, "0");

    return `${hh}:${mm}`;
  };

  const [showDetails, setShowDetails] = useState(false);

  const SkeletonProfile = () => (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 md:p-6 w-full animate-pulse">
      <div className="flex flex-col lg:flex-row items-start gap-4 md:gap-6">
        <div className="relative w-full lg:w-auto mx-auto lg:mx-0">
          <div className="w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 bg-gray-300 rounded-lg"></div>
        </div>

        <div className="flex-1 text-center lg:text-left w-full">
          <div className="h-8 bg-gray-300 rounded w-3/4 mx-auto lg:mx-0 mb-4"></div>
          <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto lg:mx-0 mb-6"></div>

          <div className="mb-4 md:mb-6">
            <div className="flex flex-col sm:flex-row items-center gap-4 bg-gray-200 rounded-xl p-3 md:p-4 border border-gray-200 max-w-2xl mx-auto lg:mx-0">
              <div className="w-24 h-20 bg-gray-300 rounded"></div>
              <div className="hidden sm:block h-12 w-px bg-gray-300"></div>
              <div className="flex-1">
                <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                <div className="space-y-2">
                  <div className="h-3 bg-gray-300 rounded w-full"></div>
                  <div className="h-3 bg-gray-300 rounded w-3/4"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 md:gap-4 justify-center lg:justify-start">
            {[...Array(4)].map((_, i) => (
              <div
                key={i}
                className="bg-gray-200 px-3 py-2 rounded-lg min-w-[100px] h-16"
              ></div>
            ))}
          </div>
        </div>

        <div className="w-full lg:w-80 xl:w-96 mt-4 lg:mt-0">
          <div className="bg-gray-200 rounded-xl border border-gray-200 p-4 md:p-6 h-64"></div>
        </div>
      </div>
    </div>
  );

  const SkeletonNavButtons = () => (
    <div className="flex flex-wrap gap-2 justify-center bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200 animate-pulse">
      {[...Array(7)].map((_, i) => (
        <div
          key={i}
          className="h-12 bg-gray-300 rounded-lg flex-1 sm:flex-none min-w-[120px]"
        ></div>
      ))}
    </div>
  );

  const SkeletonContent = () => (
    <div className="bg-white rounded-lg shadow border border-gray-200 p-6 animate-pulse">
      <div className="h-6 bg-gray-300 rounded w-1/4 mb-4"></div>
      <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
    </div>
  );

  const StarRating = ({ rating }) => {
    const filledStars = Math.round(rating);

    return (
      <div className="flex items-center gap-1 mb-2">
        {[...Array(totalStars)].map((_, i) => (
          <span
            key={i}
            className={`text-lg md:text-lg ${i < filledStars ? "text-yellow-500" : "text-gray-300"
              }`}
          >
            <TiStarFullOutline />
          </span>
        ))}
      </div>
    );
  };

  // Render content: same as before but use ComholdTaskRows where needed
  const renderActiveSection = () => {
    if (loading) {
      return <SkeletonContent />;
    }

    switch (activeSection) {
      case "accepted":
        return (
          <div className="mb-6">
            {acceptedTasks.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
                {acceptedTasks.map((task) => (
                  <div
                    key={task._id}
                    className="bg-white rounded-xl shadow-lg border border-green-200 p-3 md:p-4 hover:shadow-xl transition-all duration-300"
                  >
                    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-2 mb-3">
                      <span
                        className="px-2 py-1 bg-green-100 text-xs font-semibold rounded-full w-fit"
                        style={{
                          color: "var(--All_button_bg_color)",
                        }}
                      >
                        Running
                      </span>
                      <span
                        className="text-sm font-semibold"
                        style={{
                          color: "var(--All_button_bg_color)",
                        }}
                      >
                        Call No:{" "}
                        <span style={{ color: "black" }}>{task.CallNo}</span>
                      </span>
                    </div>

                    <h3 className="font-semibold text-gray-800 mb-2 text-sm md:text-base">
                      <div
                        style={{
                          color: "var(--All_button_bg_color)",
                        }}
                      >
                        Company:{" "}
                        <span style={{ color: "black" }}>
                          {task.CompanyName?.WhaClientName || "-"}
                        </span>
                      </div>

                      <div
                        style={{
                          color: "var(--All_button_bg_color)",
                        }}
                      >
                        Assing By:{" "}
                        <span style={{ color: "black" }}>
                          {task.SeniorDevloperID?.Name || "Admin"}
                        </span>
                      </div>
                    </h3>

                    <div className="flex justify-between items-center mt-3 md:mt-4">
                      <button
                        className="px-3 py-1  text-white text-xs rounded-lg hover:bg-blue-700 transition-colors"
                        style={{
                          backgroundColor: "var(--All_button_bg_color)",
                        }}
                        onClick={() =>
                          navigate(
                            `/InhouseRnd/CustomerrequustDetail/${task._id}`
                          )
                        }
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 bg-white rounded-lg border border-gray-200">
                <p className="text-gray-500 text-lg">No Accepted Tasks</p>
              </div>
            )}
          </div>
        );

      case "inqueue":
        return (
          <div className="mb-6">
            <div className="home_table mt-4 overflow-x-auto">
              <DynamicTable
                columns={RunningTaskColumns}
                rows={RunningTaskRows}
              />
            </div>
          </div>
        );

      case "hold":
        return (
          <div className="mb-6">
            <div className="home_table mt-4 overflow-x-auto">
              <DynamicTable columns={holdTaskColumns} rows={holdTaskRows} />
            </div>
          </div>
        );

      case "complete":
        return (
          <div className="mb-6">
            <div className="home_table mt-4 overflow-x-auto">
              <DynamicTable columns={comTaskColumns} rows={ComholdTaskRows} />
            </div>

            {ComholdTaskRows.length === 0 && (
              <div className="text-center py-8 bg-white rounded-lg border border-gray-200">
                <p className="text-gray-500 text-lg">
                  No Completed Tasks Found
                </p>
                <p className="text-gray-400 text-sm mt-2">
                  Employee has {employeeInfo?.Completed || 0} completed tasks in
                  profile
                </p>
              </div>
            )}
          </div>
        );

      case "dailywork":
        return (
          <div className="mb-6">
            <div className="home_table mt-4 overflow-x-auto">
              <DynamicTable columns={ReportColumns} rows={ReportRows} />
            </div>
          </div>
        );

      case "worksummary":
        return (
          <div className="mb-6">
            <div className="home_table mt-4 overflow-x-auto">
              <DynamicTable columns={SummaryColumns} rows={SummaryRows} />
            </div>
          </div>
        );

      case "payroll":
        return (
          <div className="mb-6">
            {/* (payroll UI unchanged) */}
            <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200 mb-4">
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-2">
                  <FaFilter
                    style={{
                      color: "var(--All_button_bg_color)",
                    }}
                  />
                  <span
                    className="font-semibold text-sm md:text-base"
                    style={{
                      color: "var(--All_button_bg_color)",
                    }}
                  >
                    Filter by Date Range:
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 w-full">
                  <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center flex-1">
                    <label
                      className="text-s font-medium  whitespace-nowrap min-w-[80px]"
                      style={{
                        color: "var(--All_button_bg_color)",
                      }}
                    >
                      Start Date:
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      value={dateRange.startDate}
                      onChange={handleDateRangeChange}
                      className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full"
                    />
                  </div>

                  <div className="flex flex-col sm:flex-row gap-2 items-start sm:items-center flex-1">
                    <label
                      className="text-s font-medium  whitespace-nowrap min-w-[80px]"
                      style={{
                        color: "var(--All_button_bg_color)",
                      }}
                    >
                      End Date:
                    </label>
                    <input
                      type="date"
                      name="endDate"
                      value={dateRange.endDate}
                      onChange={handleDateRangeChange}
                      className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-full"
                    />
                  </div>

                  <div className="flex gap-2">
                    <button
                      onClick={clearDateRange}
                      className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors whitespace-nowrap text-sm flex-1"
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>

                <div className="text-sm text-gray-600 bg-blue-50 px-3 py-2 rounded-lg text-center sm:text-left">
                  Showing {filteredInOutRows.length} of{" "}
                  {initialInOutRows.length} records
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4 mb-6">
              <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
                <div
                  className="font-semibold text-sm md:text-base"
                  style={{
                    color: "var(--All_button_bg_color)",
                  }}
                >
                  Total Days
                </div>
                <div className="text-xl md:text-2xl font-bold text-blue-600">
                  {filteredInOutRows.length}
                </div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
                <div className="font-semibold text-sm md:text-base">
                  Late Arrivals
                </div>
                <div className="text-xl md:text-2xl font-bold text-red-600">
                  {lateRows.length}
                </div>
                <div className="text-xs text-red-500">({totalLateHHMM})</div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
                <div className="font-semibold text-sm md:text-base">
                  Early Departures
                </div>
                <div className="text-xl md:text-2xl font-bold text-orange-600">
                  {earlyRows.length}
                </div>
                <div className="text-xs text-orange-500">
                  ({totalEarlyHHMM})
                </div>
              </div>
              <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
                <div className="font-semibold text-sm md:text-base">
                  Punctuality Score
                </div>
                <div className="text-xl md:text-2xl font-bold text-green-600">
                  {calculatePunctualityScore()}%
                </div>
              </div>

              <div className="bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="font-semibold text-sm md:text-base">
                    Effect on salary
                  </div>
                  <button
                    onClick={() => setShowDetails(!showDetails)}
                    className=" hover:text-black text-lg"
                    style={{
                      color: "var(--All_button_bg_color)",
                    }}
                  >
                    <RiInformation2Line />
                  </button>
                </div>

                {(() => {
                  const total = addHHMM(totalEarlyHHMM, totalLateHHMM);
                  const [hh, mm] = total.split(":").map(Number);

                  const totalHours = hh + mm / 60;
                  const hourlySalary = empdetailsidData?.isdata?.Salary
                    ? empdetailsidData.isdata.Salary / 26 / 9
                    : 0;
                  const deduction = totalHours * hourlySalary;

                  return (
                    <div className="text-sm md:text-base text-gray-700 space-y-1 mt-2">
                      <div className="font-bold text-red-500 text-lg">
                        Deduction: ₹{deduction.toFixed(2)}
                      </div>

                      {showDetails && (
                        <div className="bg-gray-100 border border-gray-300 p-3 rounded-lg shadow-md mt-3 text-sm space-y-2">
                          <div>
                            <span
                              className="font-semibold"
                              style={{
                                color: "var(--All_button_bg_color)",
                              }}
                            >
                              Total Late/Early Time:
                            </span>
                            <span className="text-orange-500 ml-2">
                              {total}
                            </span>
                          </div>

                          <div>
                            <span
                              className="font-semibold "
                              style={{
                                color: "var(--All_button_bg_color)",
                              }}
                            >
                              Hourly Salary:
                            </span>
                            <span className="text-blue-500 ml-2">
                              ₹{hourlySalary.toFixed(2)}
                            </span>
                          </div>

                          <div>
                            <span
                              className="font-semibold"
                              style={{
                                color: "var(--All_button_bg_color)",
                              }}
                            >
                              Total Hours (Decimal):
                            </span>
                            <span className="text-purple-500 ml-2">
                              {totalHours.toFixed(2)} hrs
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>
            </div>

            <div className="home_table overflow-x-auto">
              <DynamicTable
                columns={InOutColumns}
                rows={filteredInOutRows}
                getRowClassName={(params) =>
                  params.row.hasIrregularity ? "bg-yellow-50" : "bg-green-50"
                }
              />
            </div>

            {filteredInOutRows.length === 0 && (
              <div className="text-center py-8 bg-white rounded-lg border border-gray-200 mt-4">
                <p className="text-gray-500 text-lg">
                  {dateRange.startDate || dateRange.endDate
                    ? "No records found for the selected date range"
                    : "No payroll records available"}
                </p>
              </div>
            )}
          </div>
        );

      case "Customer_pending":
        if (!restrictedRoles.includes(userRole)) {
          return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
              <p className="text-gray-500 text-lg">Access Denied</p>
              <p className="text-gray-400 text-sm mt-2">
                This section is only for Customer Support roles
              </p>
            </div>
          );
        }

        return (
          <div className="mb-6">
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-4 rounded-r-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FaHeadset className="text-yellow-500 mr-2 text-xl" />
                  <h2 className="text-xl font-bold text-yellow-700">
                    Pending Customer Support Tasks
                  </h2>
                </div>
                <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-semibold">
                  {pendingCustomerRows.length} Tasks
                </span>
              </div>
              <p className="text-sm text-yellow-600 mt-1">
                Tasks awaiting action from {employeeInfo?.Name}
              </p>
            </div>

            {pendingCustomerRows.length > 0 ? (
              <div className="home_table mt-4 overflow-x-auto">
                <DynamicTable
                  columns={CustomerPendingColumns}
                  rows={pendingCustomerRows}
                />
              </div>
            ) : (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <FaHeadset className="text-gray-300 text-4xl mx-auto mb-4" />
                <p className="text-gray-500 text-lg font-medium">
                  No Pending Tasks
                </p>
                <p className="text-gray-400 text-sm mt-2">
                  All customer support tasks are up to date
                </p>
              </div>
            )}
          </div>
        );

      case "Customer_completed":
        if (!restrictedRoles.includes(userRole)) {
          return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
              <p className="text-gray-500 text-lg">Access Denied</p>
              <p className="text-gray-400 text-sm mt-2">
                This section is only for Customer Support roles
              </p>
            </div>
          );
        }

        return (
          <div className="mb-6">
            <div className="bg-green-50 border-l-4 border-green-500 p-4 mb-4 rounded-r-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FaCheckCircle className="text-green-500 mr-2 text-xl" />
                  <h2 className="text-xl font-bold text-green-700">
                    Completed Customer Support Tasks
                  </h2>
                </div>
                <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-semibold">
                  {completedCustomerRows.length} Tasks
                </span>
              </div>
              <p className="text-sm text-green-600 mt-1">
                Tasks successfully completed by {employeeInfo?.Name}
              </p>
            </div>

            {completedCustomerRows.length > 0 ? (
              <div className="home_table mt-4 overflow-x-auto">
                <DynamicTable
                  columns={CustomerCompletedColumns}
                  rows={completedCustomerRows}
                />
              </div>
            ) : (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <FaCheckCircle className="text-gray-300 text-4xl mx-auto mb-4" />
                <p className="text-gray-500 text-lg font-medium">
                  No Completed Tasks
                </p>
                <p className="text-gray-400 text-sm mt-2">
                  No customer support tasks completed yet
                </p>
              </div>
            )}
          </div>
        );

      case "Customer_rejected":
        if (!restrictedRoles.includes(userRole)) {
          return (
            <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
              <p className="text-gray-500 text-lg">Access Denied</p>
              <p className="text-gray-400 text-sm mt-2">
                This section is only for Customer Support roles
              </p>
            </div>
          );
        }

        return (
          <div className="mb-6">
            <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4 rounded-r-lg">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FaTimesCircle className="text-red-500 mr-2 text-xl" />
                  <h2 className="text-xl font-bold text-red-700">
                    Rejected Customer Support Tasks
                  </h2>
                </div>
                <span className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm font-semibold">
                  {rejectedCustomerRows.length} Tasks
                </span>
              </div>
              <p className="text-sm text-red-600 mt-1">
                Tasks rejected by {employeeInfo?.Name}
              </p>
            </div>

            {rejectedCustomerRows.length > 0 ? (
              <div className="home_table mt-4 overflow-x-auto">
                <DynamicTable
                  columns={CustomerRejectedColumns}
                  rows={rejectedCustomerRows}
                />
              </div>
            ) : (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <FaTimesCircle className="text-gray-300 text-4xl mx-auto mb-4" />
                <p className="text-gray-500 text-lg font-medium">
                  No Rejected Tasks
                </p>
                <p className="text-gray-400 text-sm mt-2">
                  No customer support tasks rejected
                </p>
              </div>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-3 md:p-4 lg:p-6">
        <div className="mb-6 md:mb-8">
          <SkeletonProfile />
        </div>

        <div className="mb-6">
          <SkeletonNavButtons />
        </div>

        <SkeletonContent />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-3 md:p-4 lg:p-6">
      {/* Header Section */}
      <div className="mb-6 md:mb-8">
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4 md:p-6 w-full">
          <div className="flex flex-col lg:flex-row items-start gap-4 md:gap-6">
            <div className="relative w-full lg:w-auto mx-auto lg:mx-0">
              <div className="w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 bg-blue-100 flex items-center justify-center border-4 border-white shadow-lg overflow-hidden rounded-lg mx-auto">
                <img
                  src={
                    employeeInfo?.ProfilePhoto
                      ? employeeInfo.ProfilePhoto
                      : defaultProfile
                  }
                  alt={employeeInfo?.Name}
                  className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    e.target.src = defaultProfile;
                  }}
                />
              </div>

              {isTopPerformer && (
                <div className="absolute top-2 right-2 z-20 animate-[fadeIn_0.3s_ease]">
                  <div
                    className="flex items-center gap-1 px-3 py-1 text-xs font-semibold text-white rounded-full shadow-lg All_button border-1"
                    style={{
                      border: "3px solid #FFD700",
                    }}
                  >
                    <FaMedal className="text-white text-sm drop-shadow" />
                    Top Performer
                  </div>
                </div>
              )}
            </div>

            <div className="flex-1 text-center lg:text-left w-full">
              <h1
                className="text-2xl lg:text-3xl font-bold  mb-2"
                style={{
                  color: "var(--All_button_bg_color)",
                }}
              >
                {employeeInfo?.Name}
              </h1>

              <p className="text-lg text-gray-600 mb-4">
                <span
                  className="font-semibold"
                  style={{
                    color: "var(--All_button_bg_color)",
                  }}
                >
                  Role:
                </span>{" "}
                {employeeInfo?.Role}
              </p>

              {isOwner && (
                <div className="mt-3 mb-4 flex flex-wrap gap-4 bg-slate-50 border border-slate-200 rounded-xl p-3 md:p-4 max-w-2xl mx-auto lg:mx-0 justify-center lg:justify-start">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-slate-700">Chat Access:</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={chatEnabledLocal}
                        onChange={handleChatAccessToggle}
                        className="sr-only peer"
                      />
                      <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-350 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-slate-700">Send Permission:</span>
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={sendEnabledLocal}
                        onChange={handleSendPermissionToggle}
                        className="sr-only peer"
                      />
                      <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-350 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-emerald-500"></div>
                    </label>
                  </div>
                </div>
              )}

              <div className="mb-4 md:mb-6">
                <div className="flex flex-col sm:flex-row items-center gap-4 bg-gray-50 rounded-xl p-3 md:p-4 border border-gray-200 max-w-2xl mx-auto lg:mx-0">
                  <div className="text-center">
                    <StarRating rating={averageRating} />
                    <div className="flex items-baseline justify-center gap-1">
                      <span className="text-xl md:text-2xl font-bold text-gray-800">
                        {averageRating.toFixed(1)}
                      </span>
                      <span className="text-xs md:text-sm text-gray-500">
                        / 10
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 mt-1">
                      {employeeInfo?.RatingRecord?.filter((r) => r && r.Rating)
                        .length || 0}{" "}
                      valid ratings
                    </p>
                  </div>

                  <div className="hidden sm:block h-8 md:h-12 w-px bg-gray-300"></div>

                  <div className="flex-1 text-center sm:text-left">
                    <p
                      className="text-sm font-semibold  mb-2"
                      style={{ color: "var(--All_button_bg_color)" }}
                    >
                      Performance Summary
                    </p>
                    <div className="space-y-1">
                      <div className="flex justify-between text-xs">
                        <span style={{ color: "var(--All_button_bg_color)" }}>
                          Total Ratings:
                        </span>
                        <span className="font-semibold text-gray-800">
                          {employeeInfo?.RatingRecord?.length || 0}
                        </span>
                      </div>
                      <div className="flex justify-between text-xs">
                        <span style={{ color: "var(--All_button_bg_color)" }}>
                          Valid Ratings:
                        </span>
                        <span className="font-semibold text-gray-800">
                          {employeeInfo?.RatingRecord?.filter(
                            (r) => r && r.Rating
                          ).length || 0}
                        </span>
                      </div>
                      <div className="flex justify-between text-xs">
                        <span style={{ color: "var(--All_button_bg_color)" }}>
                          Average Rating:
                        </span>
                        <span className="font-semibold text-green-600">
                          {averageRating.toFixed(1)}/10
                        </span>
                      </div>
                      {isTopPerformer && (
                        <div className="flex justify-between text-xs">
                          <span style={{ color: "var(--All_button_bg_color)" }}>
                            Status:
                          </span>
                          <span className="font-semibold text-yellow-600">
                            🏆 Top {employeeInfo?.Role}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 md:gap-4 justify-center lg:justify-start">
                <div className="bg-green-50 px-3 py-2 rounded-lg border border-green-200 min-w-[100px] text-center">
                  <div className="font-semibold text-green-800 text-sm">
                    Running
                  </div>
                  <div className="text-green-600 text-lg font-bold">
                    {acceptedTasks.length}
                  </div>
                </div>
                <div className="bg-yellow-50 px-3 py-2 rounded-lg border border-yellow-200 min-w-[100px] text-center">
                  <div className="font-semibold text-yellow-800 text-sm">
                    In Queue
                  </div>
                  <div className="text-yellow-600 text-lg font-bold">
                    {pendingTasks.length}
                  </div>
                </div>
                <div className="bg-purple-50 px-3 py-2 rounded-lg border border-purple-200 min-w-[100px] text-center">
                  <div className="font-semibold text-purple-800 text-sm">
                    On Hold
                  </div>
                  <div className="text-purple-600 text-lg font-bold">
                    {holdTasks.length}
                  </div>
                </div>
                <div className="bg-blue-50 px-3 py-2 rounded-lg border border-blue-200 min-w-[100px] text-center">
                  <div className="font-semibold text-blue-800 text-sm">
                    Complete
                  </div>
                  <div className="text-blue-600 text-lg font-bold">
                    {employeeInfo?.RatingRecord?.length || 0}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-80 xl:w-96 mt-4 lg:mt-0">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 md:p-6">
                <h2
                  className="text-lg md:text-xl font-bold mb-3 md:mb-4 flex items-center gap-2 justify-center lg:justify-start"
                  style={{
                    color: "var(--All_button_bg_color)",
                  }}
                >
                  <FaBusinessTime
                    className="text-blue-500"
                    style={{
                      color: "var(--All_button_bg_color)",
                    }}
                  />
                  Attendance Summary
                  <span className="text-[10px] text-gray-500 font-normal block tracking-normal normal-case mt-0.5">(Last 30 Days)</span>
                </h2>

                <div className="space-y-2 md:space-y-3">
                  <div className="flex justify-between items-center p-2 md:p-3 bg-blue-50 rounded-lg">
                    <span
                      className=" font-medium text-sm md:text-base"
                      style={{ color: "var(--All_button_bg_color)" }}
                    >
                      Total Days
                    </span>
                    <span className="text-lg font-bold text-blue-600">
                      {last30DaysRows.length}
                    </span>
                  </div>

                  <div className="flex justify-between items-center p-2 md:p-3 bg-red-50 rounded-lg">
                    <span
                      className=" font-medium text-sm md:text-base"
                      style={{ color: "var(--All_button_bg_color)" }}
                    >
                      Late Arrivals
                    </span>
                    <div className="text-right">
                      <span className="text-lg font-bold text-red-600">
                        {
                          last30DaysRows.filter(
                            (row) => row.inStatus.props.children === "Late In"
                          ).length
                        }
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center p-2 md:p-3 bg-orange-50 rounded-lg">
                    <span
                      className=" font-medium text-sm md:text-base"
                      style={{ color: "var(--All_button_bg_color)" }}
                    >
                      Early Departures
                    </span>
                    <div className="text-right">
                      <span className="text-lg font-bold text-orange-600">
                        {
                          last30DaysRows.filter(
                            (row) =>
                              row.outStatus.props.children === "Early Out"
                          ).length
                        }
                      </span>
                    </div>
                  </div>

                  <div className="flex justify-between items-center p-2 md:p-3 bg-green-50 rounded-lg">
                    <span className="text-gray-700 font-medium text-sm md:text-base">
                      On Time Days
                    </span>
                    <span className="text-lg font-bold text-green-600">
                      {last30DaysRows.filter(
                        (row) =>
                          row.inStatus.props.children !== "Late In" &&
                          row.outStatus.props.children !== "Early Out"
                      ).length}
                    </span>
                  </div>
                </div>

                <div className="mt-3 md:mt-4 pt-3 md:pt-4 border-t border-gray-200">
                  <div className="flex justify-between items-center">
                    <span
                      className="text-sm md:text-base"
                      style={{ color: "var(--All_button_bg_color)" }}
                    >
                      Punctuality
                    </span>
                    <span className="font-bold text-gray-800 text-sm md:text-base">
                      {last30DaysRows.length > 0
                        ? Math.round(
                          (last30DaysRows.filter(
                            (row) =>
                              row.inStatus.props.children !== "Late In" &&
                              row.outStatus.props.children !== "Early Out"
                          ).length /
                            last30DaysRows.length) *
                          100
                        )
                        : 100}
                      %
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mb-6">
        <div className="flex flex-wrap gap-2 justify-center bg-white p-3 md:p-4 rounded-lg shadow border border-gray-200">
          {filteredNavButtons.map((button) => {
            const IconComponent = button.icon;

            return (
              <button
                key={button.key}
                className={`px-3 py-2 md:px-4 md:py-2 rounded-lg font-medium transition-all duration-300 flex items-center gap-2 flex-1 sm:flex-none justify-center min-w-[120px] relative overflow-hidden
                        ${activeSection === button.key
                    ? "text-white shadow-lg transform scale-[1.02]"
                    : "text-white hover:shadow-md hover:transform hover:scale-[1.02]"
                  }
                    `}
                style={{
                  backgroundColor:
                    activeSection === button.key
                      ? "var(--All_button_active_color, #1e40af)"
                      : "var(--All_button_bg_color)",
                }}
                onClick={() => setActiveSection(button.key)}
              >
                <div
                  className={`absolute inset-0 bg-white opacity-0 transition-opacity duration-300
                        ${activeSection === button.key
                      ? "opacity-10"
                      : "hover:opacity-10"
                    }`}
                ></div>

                <IconComponent className="text-base relative z-10" />

                <span className="text-xs md:text-sm whitespace-nowrap relative z-10">
                  {window.innerWidth < 768
                    ? button.label.split(" ")[0]
                    : button.label}
                </span>

                <span
                  className={`px-2 py-1 text-xs rounded-full relative z-10 transition-all duration-300
                            ${activeSection === button.key
                      ? "bg-white text-black font-semibold"
                      : "bg-transparent text-white"
                    }`}
                  style={{
                    border:
                      activeSection === button.key
                        ? "none"
                        : "1px solid rgba(255,255,255,0.7)",
                  }}
                >
                  {button.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {renderActiveSection()}
    </div>
  );
};

export default EmpDetail;
